import { html, css } from "lit";
import heroImg from "../../assets/home.jpg";
import homeDarkModeImg from "../../assets/home-dark-mode.png";
import { translate } from "lit-translate";
import { BasicApp } from "../../layout/basicApp";

class IntroTab extends BasicApp {
  createRenderRoot() {
    return this;
  }



  updateUrl(url) {
    window.location.hash = url;
  }


  render() {
    return html`
        <div class="container hero-banner">
            <img id="hero-img" src="${heroImg}" alt="Woman enjoying code" class="uk-animation-slide-bottom" style="animation-delay: 400ms;">
            <img id="hero-img-dm" src="${homeDarkModeImg}" alt="Woman enjoying code" class="uk-animation-slide-bottom" style="animation-delay: 400ms;">
            <div class="hero-text uk-animation-slide-top-medium">
                <h1>${translate("intro.title")}</h1>
                <p>${translate("intro.details")}</p>
                <div class="buttons">
                    <button class="uk-button uk-button-default btn btn--outlined"
                            @click="${() => this.updateUrl('skills')}">${translate("intro.buttons.about")}
                    </button>
                    <button class="uk-button uk-button-default btn" @click="${() => this.updateUrl('projects')}">
                        ${translate("intro.buttons.projects")}
                    </button>
                </div>
            </div>
        </div>`;
  }
}

customElements.define('intro-tab', IntroTab);
